import { useEffect, useState } from "react";
import { JulebPostHogTracker, getOdooSession } from "@juleb/browser";
import { setOdooSession } from "../context/app/action";
import { useAppContext } from "../context/app/context";
import { ENV } from "../common/constants";

export const tracker = JulebPostHogTracker.getInstance();

export function useAuthenticate() {
  const appContext = useAppContext();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try {
        const authInfo = await getOdooSession();
        if (!authInfo?.uid) {
          window.location.href = `/web/login?redirect=/support/`;
          return;
        }
        if (!authInfo) {
          setLoading(false);
          return;
        } else {
          appContext.dispatch(setOdooSession(authInfo));
        }
        if (
          authInfo.uid &&
          (process.env.REACT_APP_ENV === ENV.PROD ||
            process.env.REACT_APP_ENV === ENV.DEV)
        ) {
          tracker.setup(
            {
              db: authInfo.db,
              uid: authInfo.uid,
            },
            "support"
          );
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    loading,
  };
}
